<template>
    <div>
        <hr>
        <b-message title="Logged out successfully" type="is-warning" v-model="isActive" aria-close-label="Close message">
            You've logged out successfully. We hope to see soon! 
        </b-message>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isActive: true
        }
    }
}
</script>

<style scoped>
hr {
    opacity: 0%
}
</style>
